import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import type {
  EventMarketType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import isEmpty from "lodash/isEmpty";
import BlankMarketRunnerDetails from "../BlankMarketRunnerDetails/BlankMarketRunnerDetails";
import ExchangeMarketRunnerPrice from "./components/ExchangeMarketRunnerPrice/ExchangeMarketRunnerPrice";
import "./ExchangeMarketRunnerDetails.scss";

function ExchangeMarketRunnerDetails(props: {
  market: EventMarketType;
  event: EventType;
}) {
  const { market, event } = props;

  if (!isEmpty(market.runners)) {
    <BlankMarketRunnerDetails />;
  }

  return (
    <div className={"exchange__runners"}>
      {market.runners.map((runner: EventRunnerType) => {
        const pnlColor =
          runner.runnerProfitAndLoss && runner.runnerProfitAndLoss < 0
            ? "exchange__runner-pnl--loss"
            : "exchange__runner-pnl--profit";
        return (
          <div key={runner.id} className="exchange__runner">
            <span>
              <span className={"exchange__runner-name"}>{runner.name}</span>
              {runner.runnerProfitAndLoss != null && (
                <span className={`exchange__runner-pnl ${pnlColor}`}>
                  <CurrencyNumber
                    value={runner.runnerProfitAndLoss}
                    minimumFractionDigits={0}
                  />
                </span>
              )}
            </span>
            <ExchangeMarketRunnerPrice runner={runner} event={event} />
          </div>
        );
      })}
    </div>
  );
}

export default ExchangeMarketRunnerDetails;
